import React from 'react';
import { renderRoutes } from 'react-router-config';
import Header from './components/Header';
import Footer from './components/Footer';
import { fetchCurrentUser } from './actions';
import { makeStyles } from '@material-ui/core/styles';
import { Container } from '@material-ui/core';
const useStyles = makeStyles(theme => ({
    page: {
        // overflowX: 'hidden',
        
        // [theme.breakpoints.down('sm')]: {
        //     '-webkit-overflow-scrolling': 'touch'
        // }
    }
}));

const App = ({ route }) => {

    const classes = useStyles();
    React.useEffect(() => {
        const jssStyles = document.querySelector('#jss-server-side');
        if (jssStyles) {
          jssStyles.parentElement.removeChild(jssStyles);
        }
      }, []);
    
    return (
        <React.Fragment>
            <div className={classes.page}>
                <Header />
                {renderRoutes(route.routes)}
                <Footer />
            </div>
        </React.Fragment>
    );
};

export default {
    component: App,
    loadData: ({ dispatch }) => dispatch(fetchCurrentUser())
}



// WEBPACK FOOTER //
// ./src/client/App.js